import { alertConstants } from '../constantes/alertConstants';
import { EXITO, ERROR } from '../constantes/tipoMensajeAlerta';
import { ALERTA } from '../constantes/tipoAlerta';

export function alert(state = {}, action) {
  switch (action.type) {
    case alertConstants.SUCCESS:
      return {
        tipoAlerta: ALERTA,
        tipoMensaje: EXITO,
        titulo: 'CORRECTO',
        detalle: action.message
      };
    case alertConstants.ERROR:
      return {
        tipoAlerta: ALERTA,
        tipoMensaje: ERROR,
        titulo: 'ERROR',
        detalle: action.message
      };
    case alertConstants.CLEAR:
      return {};
    default:
      return state
  }
}